<div class="modal-header">
  <h5 class="modal-title">
    {{ viewOnly ? 'ดูรายละเอียดระบบจัดการคำต้องห้าม' : (isEditMode ? 'แก้ไขระบบจัดการคำต้องห้าม' : 'เพิ่มระบบจัดการคำต้องห้าม') }}
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-8 mb-3">
        <label class="form-label required">มาตรฐานสินค้า</label>
        @if (isEditMode) {
          <input
            type="text"
            class="form-control"
            [value]="selectedStandardCodeLabel"
            readonly>
        } @else {
          <select
            class="form-select"
            formControlName="standardCodeId"
            [ngClass]="{'is-invalid': submitted && form.get('standardCodeId')?.errors}">
            <option [ngValue]="null">กรุณาเลือก</option>
            @for (item of standardCodes; track item.id ?? $index) {
              <option [ngValue]="item.id">
                {{ item.preCode || '' }} {{ item.standardCode || '' }} {{ item.title || '' }}
              </option>
            }
          </select>
          @if (submitted && form.get('standardCodeId')?.errors?.['required']) {
            <div class="invalid-feedback d-block">
              กรุณาเลือกมาตรฐานสินค้า
            </div>
          }
        }
      </div>
      <div class="col-md-4 mb-3">
        <label class="form-label">สถานะ</label>
        @if (viewOnly) {
          <input type="text" class="form-control" [value]="form.get('state')?.value === 1 ? 'เผยแพร่' : 'ไม่เผยแพร่'" readonly>
        } @else {
          <select class="form-select" formControlName="state">
            <option [ngValue]="1">เผยแพร่</option>
            <option [ngValue]="0">ไม่เผยแพร่</option>
          </select>
        }
      </div>
    </div>

    <div class="row g-4">
      <div class="col-lg-6">
        <div class="word-group major">
          <div class="group-header">
            <h6>คำต้องห้าม (Major)</h6>
            <small class="text-body-secondary">เพิ่มได้ไม่จำกัด</small>
          </div>
          @if (!viewOnly) {
            <div class="input-group mb-3">
              <input type="text" class="form-control" formControlName="majorWordInput" placeholder="พิมพ์คำต้องห้าม แล้วกด Enter"
                     (keydown.enter)="$event.preventDefault(); addWord(majorLevel)">
              <button type="button" class="btn btn-danger" (click)="addWord(majorLevel)">เพิ่ม</button>
            </div>
          }

          <div formArrayName="majorWords" class="badge-list">
            @for (control of majorWords.controls; track control.get('rowKey')?.value; let i = $index) {
              <div [formGroupName]="i" class="badge-item">
                <span class="badge text-bg-danger badge-word">{{ control.get('title')?.value }}</span>
                @if (control.get('isNew')?.value) {
                  <span class="badge text-bg-success badge-flag">ใหม่</span>
                }
                @if (!viewOnly) {
                  <button type="button" class="badge-remove text-danger" (click)="removeWord(majorLevel, i)" aria-label="ลบคำต้องห้าม">x</button>
                }
              </div>
            }
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="word-group minor">
          <div class="group-header">
            <h6>คำที่ไม่เหมาะสม (Minor)</h6>
            <small class="text-body-secondary">เพิ่มได้ไม่จำกัด</small>
          </div>
          @if (!viewOnly) {
            <div class="input-group mb-3">
              <input type="text" class="form-control" formControlName="minorWordInput" placeholder="พิมพ์คำที่ไม่เหมาะสม แล้วกด Enter"
                     (keydown.enter)="$event.preventDefault(); addWord(minorLevel)">
              <button type="button" class="btn btn-warning" (click)="addWord(minorLevel)">เพิ่ม</button>
            </div>
          }

          <div formArrayName="minorWords" class="badge-list">
            @for (control of minorWords.controls; track control.get('rowKey')?.value; let i = $index) {
              <div [formGroupName]="i" class="badge-item">
                <span class="badge text-bg-warning badge-word text-dark">{{ control.get('title')?.value }}</span>
                @if (control.get('isNew')?.value) {
                  <span class="badge text-bg-success badge-flag">ใหม่</span>
                }
                @if (!viewOnly) {
                  <button type="button" class="badge-remove text-warning-emphasis" (click)="removeWord(minorLevel, i)" aria-label="ลบคำที่ไม่เหมาะสม">x</button>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    @if (isEditMode) {
      <div class="row mt-3">
        <div class="col-md-6 mb-3">
          <label for="recordedBy" class="form-label">ผู้บันทึก</label>
          <input id="recordedBy" class="form-control" [value]="recordedByDisplay" readonly>
        </div>
        <div class="col-md-6 mb-3">
          <label for="recordedAt" class="form-label">วันที่บันทึก</label>
          <input id="recordedAt" class="form-control" [value]="recordedAtDisplay" readonly>
        </div>
      </div>
    }
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()">{{ viewOnly ? 'ปิด' : 'ยกเลิก' }}</button>
  @if (!viewOnly) {
    <button type="button" class="btn btn-primary" (click)="save()" [disabled]="isSubmitting">บันทึก</button>
  }
</div>
